export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1b3d70] to-[#2a5490] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/f0504b97139bc354dc5720a1b109b5af/0617c5e7d9074a8be697d2f0e79bec75.png" 
                alt="UNAM Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h3 className="text-xl font-bold">Speed Mentoring</h3>
                <p className="text-sm text-[#bb8800]">UNAM</p>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Conectando estudiantes con expertos de la industria para impulsar el desarrollo profesional en el área de computación.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('bienvenida')}
                  className="text-sm text-white/80 hover:text-[#bb8800] transition-colors cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('como-funciona')}
                  className="text-sm text-white/80 hover:text-[#bb8800] transition-colors cursor-pointer"
                >
                  Cómo Funciona
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('importancia')}
                  className="text-sm text-white/80 hover:text-[#bb8800] transition-colors cursor-pointer"
                >
                  Importancia
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('mentores')}
                  className="text-sm text-white/80 hover:text-[#bb8800] transition-colors cursor-pointer"
                >
                  Mentores
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#bb8800] text-lg mt-0.5"></i>
                <span className="text-sm text-white/80">jinformatica@acatlan.unam.mx</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#bb8800] text-lg mt-0.5"></i>
                <span className="text-sm text-white/80">Facultad de Estudios Superiores Acatlán</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-base font-bold mb-4">Síguenos</h4>
            <div className="flex gap-3 mb-6">
              <a 
                href="https://www.facebook.com/coordinacionmac" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#bb8800] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://x.com/coordinacionmac?t=8TyFi9J5TkRX5F05BVxH8w&s=09" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#bb8800] transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a 
                href="https://www.instagram.com/coordinacionmac/" 
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#bb8800] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
            <p className="text-sm text-white/80">
              Mantente actualizado con las últimas noticias y oportunidades de mentoría.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
}